import { render, staticRenderFns } from "./DashboardWeeklyChart.vue?vue&type=template&id=5fd63fdb&"
import script from "./DashboardWeeklyChart.vue?vue&type=script&lang=js&"
export * from "./DashboardWeeklyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports